import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class LocaleMappingService {
	constructor() {}

	/**
	 * Takes an accesso provided locale and returns a dayjs & angular equivalent when needed
	 * NOTE: Errors to console and returns original locale if no matches
	 * @param locale
	 * @public
	 */
	public localeConvert(locale: string): string {
		const newLocale = locale.replace('_', '-');
		switch (newLocale.toLowerCase()) {
			case 'it-it':
			case 'it':
				return 'it';
			case 'de-de':
				return 'de';
			case 'fr-fr':
				return 'fr';
			case 'ja-jp':
				return 'ja';
			case 'pt-br':
				return 'pt';
			case 'da-dk':
				return 'da';
			case 'pt-pt':
				return 'pt';
			case 'sv-se':
				return 'sv';
			case 'es-es':
				return 'es';
			case 'zh-hant':
			case 'zh-hans':
			case 'zh-hans-cn':
				return 'zh';
			case 'en-fr':
				return 'en-GB';
			case 'en-us':
			case 'en':
				// loading the canadian date locale data because plain english doesn't have all the data we need for dayJs
				return 'en-CA';
			default:
				console.warn(`>>> Unable to find dayjs equivalent locales for => ${newLocale.toLowerCase()}`);
				console.warn(`>>> continuing to use ${newLocale}`);
				return newLocale;
		}
	}
}
